import { useState } from "react";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PushToProductionDialog } from "./PushToProductionDialog";

interface PushToProductionButtonProps {
  collectionId: string;
  collectionName: string;
}

export function PushToProductionButton({
  collectionId,
  collectionName,
}: PushToProductionButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
        <Upload className="h-4 w-4 mr-1.5" />
        Push to Prod
      </Button>
      <PushToProductionDialog
        open={open}
        onOpenChange={setOpen}
        collectionId={collectionId}
        collectionName={collectionName}
      />
    </>
  );
}
